import { BaseModel } from '../../../../../../core/_base/crud';

    export class LsxphongCanKetQuaSx extends BaseModel{

        static category_path = "SXPCPL";
        static optionsTinhTrang:any = [
            {
                id: 1,
                name: 'Đang soạn thảo',
                value: 'SXPCPL_DANGSOANTHAO',
            },
            {
                id: 2,
                name: 'Chờ xác nhận',
                value: 'SXPCPL_CHOXACNHAN',
            },
            {
                id: 3,
                name: 'Không xác nhận',
                value: 'SXPCPL_KHONGXACNHAN',
            },
            {
                id: 4,
                name: 'Chờ kiểm tra',
                value: 'SXPCPL_CHOKIEMTRA',
            },
            {
                id: 5,
                name: 'Không kiểm tra',
                value: 'SXPCPL_KHONGKIEMTRA',
            },
            {
                id: 6,
                name: 'Hoàn tất',
                value: 'SXPCPL_HOANTAT',
            },
            {
                id: 7,
                name: 'Đã hủy',
                value: 'SXPCPL_DAHUY',
            }
        ];

        Id: number
        KeHoachPhongCanId: number
        NgaySanXuat: string
        DatHangCtId: number
        ThanhPhamId: number
        MaHangTP: string
        TenHangTP: string
        QuyCachTP: string
        ThanhPhamKhoiLuong: number
        HangHoaId: number
        MaHangCT: string
        TenHangCT: string
        Dvt: number
        TenDVT: string
        KhoiLuongTheoMeTron: number
        SoLuongMeTron: number
        Nstb: number
        Cn: number
        TrangThai: string
        GhiChu: string
        SoLuongMeTronThucTe: number
        SoLuongMeTronThucTeThayDoi: number
        NguoiTao: number
        TenNguoiTao: string
        NgayTao: string
        NguoiGuiXacNhan: number
        TenNguoiGui: string
        NgayGuiXacNhan: string
        IsEnable_Duyet: boolean
        IsVisible_Duyet: boolean
        isDuyet: boolean
        LyDoDuyet: string
        listLOT: string[]
        listLsxphongCanKetQuaSxLsThaoTac: LsxphongCanKetQuaSxLsThaoTac[]
        listDuLieuDNNKKetQuaSX: DuLieuDNNKKetQuaSX[]

        clear(){
            this.Id = 0;
            this.KeHoachPhongCanId = 0;
            this.NgaySanXuat = '';
            this.DatHangCtId = 0;
            this.ThanhPhamId = 0;
            this.MaHangTP = '';
            this.TenHangTP = '';
            this.QuyCachTP = '';
            this.ThanhPhamKhoiLuong = 0;
            this.HangHoaId = 0;
            this.MaHangCT = '';
            this.TenHangCT = '';
            this.Dvt = 0;
            this.TenDVT = '';
            this.KhoiLuongTheoMeTron = 0;
            this.SoLuongMeTron = 0;
            this.Nstb = 0;
            this.Cn = 0;
            this.TrangThai = '';
            this.GhiChu = '';
            this.SoLuongMeTronThucTe = 0;
            this.SoLuongMeTronThucTeThayDoi = 0;
            this.NguoiTao = 0;
            this.TenNguoiTao  = '';
            this.NgayTao  = '';
            this.NguoiGuiXacNhan = 0;
            this.TenNguoiGui = '';
            this.NgayGuiXacNhan ='';
            this.IsEnable_Duyet = false;
            this.IsVisible_Duyet = false;
            this.isDuyet = false;
            this.LyDoDuyet = '';
            this.listLOT = [];
            this.listLsxphongCanKetQuaSxLsThaoTac = [];
            this.listDuLieuDNNKKetQuaSX = [];
        }
        copy(item: LsxphongCanKetQuaSx){
            this.Id = item.Id;
            this.KeHoachPhongCanId = item.KeHoachPhongCanId;
            this.NgaySanXuat = item.NgaySanXuat;
            this.DatHangCtId = item.DatHangCtId;
            this.ThanhPhamId = item.ThanhPhamId;
            this.MaHangTP = item.MaHangTP;
            this.TenHangTP = item.TenHangTP;
            this.QuyCachTP = item.QuyCachTP;
            this.ThanhPhamKhoiLuong = item.ThanhPhamKhoiLuong;
            this.HangHoaId = item.HangHoaId;
            this.MaHangCT = item.MaHangCT;
            this.TenHangCT = item.TenHangCT;
            this.Dvt = item.Dvt;
            this.TenDVT = item.TenDVT;
            this.KhoiLuongTheoMeTron = item.KhoiLuongTheoMeTron;
            this.SoLuongMeTron = item.SoLuongMeTron;
            this.Nstb = item.Nstb;
            this.Cn = item.Cn;
            this.TrangThai = item.TrangThai;
            this.GhiChu = item.GhiChu;
            this.SoLuongMeTronThucTe = item.SoLuongMeTronThucTe;
            this.SoLuongMeTronThucTeThayDoi = item.SoLuongMeTronThucTeThayDoi;
            this.NguoiTao = item.NguoiTao;
            this.TenNguoiTao  = item.TenNguoiTao;
            this.NgayTao  = item.NgayTao;
            this.NguoiGuiXacNhan = item.NguoiGuiXacNhan;
            this.TenNguoiGui = item.TenNguoiGui;
            this.NgayGuiXacNhan = item.NgayGuiXacNhan;
            this.IsEnable_Duyet = item.IsEnable_Duyet;
            this.IsVisible_Duyet = item.IsVisible_Duyet;
            this.isDuyet = item.isDuyet;
            this.LyDoDuyet = item.LyDoDuyet;
            this.listLOT = item.listLOT;
            this.listLsxphongCanKetQuaSxLsThaoTac = item.listLsxphongCanKetQuaSxLsThaoTac;
            if(item.listDuLieuDNNKKetQuaSX == null || item.listDuLieuDNNKKetQuaSX.length == 0)
                this.listDuLieuDNNKKetQuaSX = [];
            else
                this.listDuLieuDNNKKetQuaSX = item.listDuLieuDNNKKetQuaSX;
        }
    }
    export class LsxphongCanKetQuaSxLsThaoTac extends BaseModel{
        Id: number;
        SxLsxphongCanKetQuaSxId: number;
        NguoiThaoTac: number;
        TenNguoiThaoTac: string;
        NgayThaoTac: string;
        LoaiThaoTac: string;
        NoiDung: string;
        GhiChu: string;

        clear(){
            this.Id = 0;
            this.SxLsxphongCanKetQuaSxId = 0;
            this.NguoiThaoTac = 0;
            this.TenNguoiThaoTac = '';
            this.NgayThaoTac = '';
            this.LoaiThaoTac = '';
            this.NoiDung = '';
            this.GhiChu = '';
        }

        copy(item: LsxphongCanKetQuaSxLsThaoTac){
            this.Id = item.Id;
            this.SxLsxphongCanKetQuaSxId = item.SxLsxphongCanKetQuaSxId;
            this.NguoiThaoTac = item.NguoiThaoTac;
            this.TenNguoiThaoTac = item.TenNguoiThaoTac;
            this.NgayThaoTac = item.NgayThaoTac;
            this.LoaiThaoTac = item.LoaiThaoTac;
            this.NoiDung = item.NoiDung;
            this.GhiChu = item.GhiChu;
        }
    }
    export class DuLieuDNNKKetQuaSX{
        IdPhieu: number
        SoPhieu: string

        clear(){
           this.IdPhieu = 0;
           this.SoPhieu = ''; 
        }

        copy(item: DuLieuDNNKKetQuaSX){
            this.IdPhieu = item.IdPhieu;
            this.SoPhieu = item.SoPhieu;
        }
    }
